import React, { type ButtonHTMLAttributes } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import './style.scss';

export type SearchForumHeaderSearchBarProps = ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * This is a "fake" searchbar. A button that looks like a searchbar, but only has an
 * onClick function.
 */
const SearchForumHeaderSearchBar: React.FC<SearchForumHeaderSearchBarProps> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'components.search_forum.search_bar' });

  const classes = c('SearchForum__HeaderSearchBar', 'SearchForum__SearchBar', className);

  return (
    <div className={classes}>
      <button {...restProps} type="button" className="SearchBar__inner">
        {t('title')}
      </button>
    </div>
  );
};

export default SearchForumHeaderSearchBar;
